import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';

// ----------------------------------------------------------------------


const axiosInstance = axios.create({ baseURL: HOST_API_KEY, withCredentials: "true", credentials: "include" });

axiosInstance.interceptors.request.use((config)=>{
  config.headers.Authorization = `Bearer ${localStorage.getItem("accessToken")}`
  return config
})

axiosInstance.interceptors.response.use(
  (config) => config,
  async (error) => {
    const originaRequest = error.config;
    if(error.response?.status === 401 && error.config && !error.config._isRetry ){
      originaRequest._isRetry = true
      try{
        const response = await axios.post(`${HOST_API_KEY}/refresh-tokens-admin`,{}, {withCredentials: "true", credentials: "include"})
        if (response.data.accessToken) {
          localStorage.setItem('accessToken', response.data.accessToken);
        } else {
          localStorage.removeItem('accessToken');
        }
        return axiosInstance.request(originaRequest)
      }catch(e){
       return Promise.reject((e.response && e.response.data) || 'Something went wrong')
      }
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);


export default axiosInstance;
